import axios from 'axios';
import router from '@/router';
import store from '@/store/store';

axios.defaults.baseURL = process.env.VUE_APP_BASE_URI;
axios.defaults.withCredentials = true;

export const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BASE_URI,
  withCredentials: true,
  // headers: {'X-Requested-With': 'XMLHttpRequest'},
});

// Add a response interceptor

const errroHandler = function (error) {
  console.error(
    'axios interceptors - backend error status code:',
    error.response.status,
    error.response
  );
  
  const redirectUrl = router.currentRoute.path;
  switch (error.response.status) {
    case 401: // Not logged in
    case 419: // Session expired
    case 503: // Down for maintenance
      // Bounce the user to the login screen with a redirect back
      store.commit('SET_AUTHENTICATED', false);
      store.commit('SET_USER', null);
      store.commit('SET_SESSION_COOKIE', null);
      store.commit('SET_USER_ID', null);

      console.log('Request login after session expired for path:', redirectUrl);
      router.push('/signin?url=' + redirectUrl);
      //router.push('/signin');
      
      break;
    case 500:
      alert('Oops, something went wrong!  The team have been notified.');
      break;
    default:
      // Allow individual requests to handle other errors
      return Promise.reject(error);
  }
};

HTTP.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, errroHandler);

export const HTTP_APP = axios.create({
  baseURL: process.env.VUE_APP_BASE_APP_URI,
  withCredentials: true,
  // headers: {'X-Requested-With': 'XMLHttpRequest'},
});

HTTP_APP.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, errroHandler);
